import type { PropsWithChildren } from 'react';

import { Typography } from 'src/app/components/Elements/Typography';
import type { ThemeSpaceType } from 'src/styles/theme';

import { StandardCard } from './styles';

interface CardWithInnerTitleProps
  extends PropsWithChildren<{
    cardTitle: string;
    cardTitleMarginBottom?: ThemeSpaceType;
    className?: string;
    [key: `data-${string}`]: any;
  }> {}

export const CardWithInnerTitle = ({
  className,
  cardTitle,
  children,
  cardTitleMarginBottom = 's5',
  ...rest
}: CardWithInnerTitleProps) => {
  return (
    <StandardCard className={className} {...rest}>
      <Typography variant="h3" marginBottom={cardTitleMarginBottom}>
        {cardTitle}
      </Typography>
      {children}
    </StandardCard>
  );
};
